'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--Leaf';

var EntypoLeaf = function EntypoLeaf(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M19.025,3.587c-4.356,2.556-4.044,7.806-7.096,10.175c-2.297,1.783-5.538,0.88-7.412,0.113c0,0-1.27,1.603-2.181,3.74c-0.305,0.717-1.644-0.073-1.409-0.68C3.905,9.25,14.037,5.416,14.037,5.416S6.888,5.113,2.11,11.356C1.982,9.93,1.77,6.072,5.47,3.706C10.486,0.495,20.042,2.991,19.025,3.587z' })
    );
};

exports.default = EntypoLeaf;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-entypo-icons/lib/entypo/Leaf.js
// module id = 643
// module chunks = 168707334958949